import Vue from 'vue'
import VueRouter from 'vue-router'
import CategoryOverview from '../components/pages/category/CategoryOverview.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'categoryOverview',
        component: CategoryOverview
    },
    {
        path: '/category/:categoryId/faq/:faqId?',
        name: 'faq_list',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "category_detail" */ '../components/pages/faq/FAQList.vue'),
        props: true
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
